import { UpgradePageQuery } from './UpgradePageQuery'
import { deserializePlanPurchaseExperienceModeQueryParam } from '@dtx-company/true-common/src/query-string-serialization/planPurchaseExperienceMode/deserializePlanPurchaseExperienceModeQueryParam'
import { deserializePlanTypeQueryParam } from '@dtx-company/true-common/src/query-string-serialization/planType/deserializePlanTypeQueryParam'
import { useFlowRouter } from '@dtx-company/inter-app/src/hooks/useFlowRouter'
import { useMemo } from 'react'

export function useUpgradePageQuery(): UpgradePageQuery {
  const flowRouter = useFlowRouter()
  return useMemo(() => {
    return {
      from: flowRouter.getString('from'),
      mode: deserializePlanPurchaseExperienceModeQueryParam(flowRouter.getString('mode')),
      planType: deserializePlanTypeQueryParam(flowRouter.getString('planType')),
      promoCode: flowRouter.getString('promoCode')
    }
  }, [flowRouter])
}
